/** Change against the previous year as a StatCard delta (none without a base). */
export function change(current: number, previous: number, label: string) {
  if (previous === 0) return undefined;
  const pct = Math.round(((current - previous) / Math.abs(previous)) * 100);
  return {
    value: `${pct > 0 ? '+' : ''}${pct} %`,
    direction: (pct === 0 ? 'flat' : pct > 0 ? 'up' : 'down') as 'up' | 'down' | 'flat',
    label,
  };
}

/** Years to choose from: the given ones plus this year, newest first. */
export function yearOptions(thisYear: number, years: number[]) {
  return Array.from(new Set([thisYear, ...years]))
    .sort((a, b) => b - a)
    .map((y) => ({ value: String(y), label: String(y) }));
}
